<div class="entity-not-found text-center" data-testid="entity-not-found">
  <div class="entity-not-found__icon mb-4">
    <i class="fas fa-search fa-4x"></i>
  </div>
  <h2 class="entity-not-found__title mb-3">
    {{ "We couldn't find this" | translate }} {{ resourceLabel | translate }}
  </h2>
  <p class="entity-not-found__hint text-muted mb-4">
    {{ 'It may have been deleted or the link is no longer valid.' | translate }}<span *ngIf="hintSuffix"><br>{{ hintSuffix | translate }}</span>
  </p>
  <div class="entity-not-found__actions mb-4">
    <a [routerLink]="backTo" class="btn btn-primary btn-lg">{{ backLabel | translate }}</a>
  </div>
  <p *ngIf="id" class="entity-not-found__ref small text-muted mb-0">
    {{ 'Reference' | translate }}
    <span class="entity-not-found__id-badge" [class.is-copied]="copied">
      <code>{{ id }}</code>
      <button type="button"
              class="entity-not-found__copy-btn"
              (click)="copyLink()"
              [attr.aria-label]="(copied ? 'Link copied' : 'Report a broken link') | translate"
              [title]="(copied ? 'Link copied' : 'Report a broken link') | translate">
        <i class="fas" [class.fa-check]="copied" [class.fa-copy]="!copied"></i>
      </button>
    </span>
  </p>
</div>
